import StatusExample from "./examples/Status.Example";

export default [
    {
        title: "Basic status samples",
        component: StatusExample,
        code: require("!raw-loader!./examples/Status.Example.tsx"),
        dependencies: {
            "Status.Example.css": require("!raw-loader!./examples/Status.Example.css")
        }
    }
];
